/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useContext, useState, useRef, useMemo } from 'react'
import {
  strCol,
  intCol,
  numCol,
  dateTimeCol,
} from '@integec/grid-tools/lib/cols'
import {
  modifiedDateCol,
  utilityHeader,
  unitHeader,
} from 'core/HeaderColTypeProps'
import {
  getApiTargetInfo,
  getUtilityNameMap,
  getUnitNameMap,
  UnitSelection,
  ExportComponent,
} from 'core'
import { connect } from 'react-redux'
import moment from 'moment'

import {
  rowHeaderRender,
  hasAccesPermits,
  exportDataComponent,
  isValidYearRange,
} from 'core/utils'
import { Tabs, Button, Input, DatePicker, Radio, message } from 'antd'
import {
  SpinContext,
  ErrorContext,
  UnitSelectionContext,
  DatePickerContext,
} from 'context'
import Grid, {
  virtualizedGridRenderer,
  defaultVirtualizedCellRender,
} from '@integec/grid-tools'
import {
  CriteriaRow,
  Title,
  Content,
  FullHeightSizer,
  Filler,
} from 'core/screen-util'

import { getCardHistoryAll } from 'api/pgads.js'

import * as ScreenPermissions from 'core/EventActions'
import {
  getPermitActions,
  getEnvConfig,
  getValidYearRange,
} from 'core/selectors'

const { TabPane } = Tabs
const modifierGetter = ({ rowData }) =>
  rowData && rowData.modificationInfo ? rowData.modificationInfo.user : ''

const CardHistory = ({ apiTargetInfo, actionPermits, envConfig, ...props }) => {
  const title = 'Card Modification History'
  const { selectedDateRangePicker, setSelectedDateRagePicker } = useContext(
    DatePickerContext
  )
  const { selectedUnits, setVisibleUnitSelection } = useContext(
    UnitSelectionContext
  )
  // const [loading, setLoading] = useState(false)
  const { spinning, setSpinning } = useContext(SpinContext)
  const [fuzzyFilter, setFuzzyFilter] = useState('')
  const [modificationType, setModificationType] = useState('ALL')
  // const [err, setError] = useState()

  const { setError } = useContext(ErrorContext)
  const [card95, setCard95] = useState([])
  const [card99, setCard99] = useState([])
  const [card97, setCard97] = useState([])

  const [selectedTab, setSelectedTab] = useState('card95')

  const cardFreezeAccess = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.CARD_FREEZE],
        matchAny: true,
      }),
    [actionPermits]
  )

  // const setErr = err => {
  //   setError(err)
  //   setLoading(false)
  // }

  const onRetrieve = ({ selUnits = selectedUnits }) => {
    const isValid = isValidYearRange(
      props.validYearRange,
      selectedDateRangePicker[0],
      selectedDateRangePicker[1]
    )
    if (!isValid) return

    if (selUnits.length < 1) {
      message.error('Please , Select Units')
      setVisibleUnitSelection(true)
      return
    }
    setSpinning(true)
    const data = {
      fromMonth: selectedDateRangePicker[0].format('MM'),
      fromYear: selectedDateRangePicker[0].format('YYYY'),
      toMonth: selectedDateRangePicker[1].format('MM'),
      toYear: selectedDateRangePicker[1].format('YYYY'),
      // utility: selectedUtility,
      allOrLrRadio: modificationType,
    }

    getCardHistoryAll(apiTargetInfo)(data)(selUnits.map(u => u.unitId)).fork(
      setError,
      cardData => {
        setCard95(cardData.cardhistory95)
        setCard97(cardData.cardhistory97)
        setCard99(cardData.cardhistory99)
        setSpinning(false)
      }
    )
  }

  const headerWithFormatter = headers =>
    headers.map(header =>
      header.ident === 'utility'
        ? {
            ...header,
            // ...toSelectionColProps(utilityNameMap),
            // dataFormatter: ({ value }) => utilityNameMap[value] || value,
            sortIndexGetter: ({ rowData }) =>
              rowData.utility.substring(
                rowData.utility.indexOf('-'),
                rowData.utility.length
              ),
          }
        : header.ident === 'unit'
        ? {
            ...header,
            // ...toSelectionColProps(unitNameMap),
            // dataFormatter: ({ value }) => unitNameMap[value] || value,
            sortIndexGetter: ({ rowData }) =>
              rowData.unit.substring(
                rowData.unit.indexOf('-'),
                rowData.unit.length
              ),
          }
        : header
    )
  const GridCard95 = useRef()
  const GridCard97 = useRef()
  const GridCard99 = useRef()
  const exportData = _ => {
    // if (exportList.includes('95'))
    new ExportComponent({
      getData: _ => exportDataComponent(GridCard95, card95 || [], fuzzyFilter),
      headers: Card95Headers,
      data: card95 || [],
      fileName: `Card 95 Modification History-${moment().format('MM/DD/YYYY')}`,
    }).exportCSVData()

    new ExportComponent({
      getData: _ => exportDataComponent(GridCard97, card97 || [], fuzzyFilter),
      headers: Card97Headers,
      data: card97 || [],
      fileName: `Card 97 Modification History-${moment().format('MM/DD/YYYY')}`,
    }).exportCSVData()

    new ExportComponent({
      getData: _ => exportDataComponent(GridCard99, card99 || [], fuzzyFilter),
      headers: Card99Headers,
      data: card99 || [],
      fileName: `Card 99 Modification History-${moment().format('MM/DD/YYYY')}`,
    }).exportCSVData()
  }

  const Card95Headers = useMemo(() => {
    return cardFreezeAccess ? Card95HeadersFreezColumns : Card95HeadersNonFreeze
  }, [cardFreezeAccess])

  const Card97Headers = useMemo(() => {
    return cardFreezeAccess
      ? Card97HeadersFreezeColumn
      : Card97HeadersNonFreezecolumn
  }, [cardFreezeAccess])

  const Card99Headers = useMemo(() => {
    return cardFreezeAccess
      ? Card99HeadersFreezcolumns
      : Card99HeadersNonFreezeColumn
  }, [cardFreezeAccess])

  return (
    <>
      <UnitSelection
        accesskey="u"
        retrieveData={onRetrieve}
        // renderContent={renderUnitContentByCollapse({
        //   utilityUnitMap,
        //   utilityNameMap,
        //   unitNameMap,
        //   setSelectedUnits,
        //   selectedUnits,
        //   units,
        // })}
      />
      <CriteriaRow>
        <Title
          style={{
            marginRight: '15px',
            marginBottom: '5px',
          }}
        >
          {title}
        </Title>
        <DatePicker.RangePicker
          allowClear={false}
          mode={['month', 'month']}
          format="MMMM-YYYY"
          value={selectedDateRangePicker}
          placeholder={['Start month', 'End month']}
          onChange={value => {
            setSelectedDateRagePicker([
              value[0].startOf('month'),
              value[1].endOf('month'),
            ])
          }}
          onPanelChange={value => {
            setSelectedDateRagePicker([
              value[0].startOf('month'),
              value[1].endOf('month'),
            ])
          }}
        />
        <Radio.Group
          defaultValue="ALL"
          value={modificationType}
          onChange={e => setModificationType(e.target.value)}
          buttonStyle="solid"
          style={{ marginLeft: '20px' }}
        >
          <Radio value="ALL">All Modifications</Radio>
          <Radio value="LR">Lock Release Modifications</Radio>
        </Radio.Group>
        <Button
          type="primary"
          onClick={onRetrieve}
          loading={spinning}
          style={{ marginLeft: 20 }}
          icon="database"
        >
          Retrieve
        </Button>
        <Filler />
        <Button
          onClick={exportData}
          style={{ marginRight: '20px' }}
          // type="primary"
          icon="export"
        >
          Export
        </Button>
      </CriteriaRow>
      <FullHeightSizer heightOffset={300}>
        {({ height, width }) => (
          <Content style={{ height: height, paddingTop: '0px' }}>
            <Tabs
              type="card"
              defaultActiveKey="card95"
              onChange={setSelectedTab}
              style={{ height: 'inherit', paddingTop: '5px' }}
              activeKey={selectedTab}
              tabBarExtraContent={
                <div style={{ paddingRight: '50px' }}>
                  <Input.Search
                    placeholder="Filter"
                    value={fuzzyFilter}
                    css={{ marginLeft: '10px', marginRight: '20px' }}
                    onChange={e => setFuzzyFilter(e.target.value)}
                  />
                </div>
              }
            >
              {hasAccesPermits({
                authGodMode: envConfig.authGodMode,
                actionPermits,
                eventActions: [ScreenPermissions.CARD95_HISTORY_VIEWER],
                matchAny: true,
              }) && (
                <TabPane tab="Card 95" key="card95" forceRender>
                  <Grid
                    ref={GridCard95}
                    sortEnabled
                    isEditable={false}
                    data={card95}
                    headers={headerWithFormatter(Card95Headers)}
                    altBgColor="#ebebeb"
                    render={virtualizedGridRenderer({
                      autoFixColByKey: cardFreezeAccess,
                      rowHeaderRender,
                      height: height - 90,
                      width: width - 70,
                      // headerRowHeight: 30,
                      cellRender,
                    })}
                    initialSortOptions={[
                      utilityHeader,
                      unitHeader,
                      {
                        ident: 'year',
                        sortOrder: 'asc',
                      },
                      {
                        ident: 'month',
                        display: 'Month',
                        sortOrder: 'asc',
                      },
                    ]}
                    fuzzyFilter={fuzzyFilter}
                  />
                </TabPane>
              )}

              {hasAccesPermits({
                authGodMode: envConfig.authGodMode,
                actionPermits,
                eventActions: [ScreenPermissions.CARD97_HISTORY_VIEWER],
                matchAny: true,
              }) && (
                <TabPane tab="Card 97" key="card97" forceRender>
                  <Grid
                    ref={GridCard97}
                    sortEnabled
                    isEditable={false}
                    data={card97}
                    headers={headerWithFormatter(Card97Headers)}
                    altBgColor="#ebebeb"
                    render={virtualizedGridRenderer({
                      autoFixColByKey: cardFreezeAccess,
                      rowHeaderRender,
                      height: height - 90,
                      width: width - 70,
                      headerRowHeight: 60,
                      cellRender,
                    })}
                    fuzzyFilter={fuzzyFilter}
                    initialSortOptions={[
                      utilityHeader,
                      unitHeader,
                      {
                        ident: 'year',
                        sortOrder: 'asc',
                      },
                      {
                        ident: 'eventNum',
                        sortOrder: 'asc',
                      },
                      {
                        ident: 'eventIdx',
                        sortOrder: 'asc',
                      },
                    ]}
                  />
                </TabPane>
              )}

              {hasAccesPermits({
                authGodMode: envConfig.authGodMode,
                actionPermits,
                eventActions: [ScreenPermissions.CARD99_HISTORY_VIEWER],
                matchAny: true,
              }) && (
                <TabPane tab="Card 99" key="card99" forceRender>
                  <Grid
                    ref={GridCard99}
                    sortEnabled
                    isEditable={false}
                    data={card99}
                    headers={headerWithFormatter(Card99Headers)}
                    altBgColor="#ebebeb"
                    render={virtualizedGridRenderer({
                      autoFixColByKey: cardFreezeAccess,
                      rowHeaderRender,
                      height: height - 90,
                      width: width - 70,
                      // headerRowHeight: 30,
                      cellRender,
                    })}
                    fuzzyFilter={fuzzyFilter}
                    initialSortOptions={[
                      utilityHeader,
                      unitHeader,
                      {
                        ident: 'year',
                        sortOrder: 'asc',
                      },
                      {
                        ident: 'month',
                        display: 'Month',
                        sortOrder: 'asc',
                      },
                    ]}
                  />
                </TabPane>
              )}
            </Tabs>
          </Content>
        )}
      </FullHeightSizer>
    </>
  )
}

const mapStateToProps = state => ({
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  apiTargetInfo: getApiTargetInfo(state),
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
  validYearRange: getValidYearRange(state),
})

export default connect(mapStateToProps)(CardHistory)

export const cellRender = props => {
  const { gridToolProps, reactVirtualizedProps } = props
  const { data } = gridToolProps
  const { style, rowIndex } = reactVirtualizedProps
  const { status } = data[rowIndex]

  // const style = reactVirtualizedProps.style
  return defaultVirtualizedCellRender({
    ...props,
    style: {
      ...style,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      borderTop: '1px solid #cc',
      backgroundColor: status === 'OLD' ? '#F08080' : undefined,
    },
  })
}

const Card95HeadersNonFreeze = [
  utilityHeader,
  unitHeader,
  intCol({
    ident: 'year',
    display: 'Year',
    isFiltered: true,
    isKey: true,
  }),
  intCol({
    ident: 'month',
    display: 'Month',
    isFiltered: true,
    isKey: true,
  }),
  dateTimeCol({
    ident: 'createdDate',
    display: 'Created Date',
    width: 200,
  }),

  modifiedDateCol,
  strCol({
    ident: 'createdBy',
    display: 'Created By',
  }),
  // modifierCol,
  {
    ident: 'modifier',
    display: 'Modifier',
    dataGetter: modifierGetter,
    showInRowEditor: false,
    type: 'str',
    width: 100,
    isKey: true,
  },
  strCol({
    ident: 'status',
    display: 'Status',
  }),
  strCol({
    ident: 'deleted',
    display: 'Deleted',
  }),

  numCol({
    ident: 'netMaxCap',
    display: 'Net Maximum Capacity',
  }),
  numCol({
    ident: 'netDapCap',
    display: 'Net Dependable Capacity',
  }),
  numCol({
    ident: 'netActGen',
    display: 'Net Actual Generation',
  }),
  numCol({
    ident: 'loadChar',
    display: 'Load Characteristics',
  }),
  numCol({
    ident: 'attStart',
    display: 'Attempted Starts',
  }),
  numCol({
    ident: 'actualStart',
    display: 'Actual Starts',
  }),
  strCol({
    ident: 'loadDesc',
    display: 'Load Description',
  }),
  numCol({
    ident: 'servHour',
    display: 'Service Hours',
  }),
  numCol({
    ident: 'resHour',
    display: 'Reserve Hours',
  }),
  numCol({
    ident: 'pumpHour',
    display: 'Pump Hours',
  }),
  numCol({
    ident: 'syncHour',
    display: 'Synchronous Hours',
  }),
].map(e => ({ ...e, isFiltered: true }))

const Card95HeadersFreezColumns = [
  unitHeader,
  intCol({
    ident: 'year',
    display: 'Year',
    isFiltered: true,
    isKey: true,
    width: 80,
  }),
  intCol({
    ident: 'month',
    display: 'Month',
    isFiltered: true,
    isKey: true,
    width: 70,
  }),
  strCol({
    ident: 'utility',
    display: 'Utility',
    width: 350,
    // isKey: true,
    sortOrder: 'asc',
    ellipsis: true,
  }),
  dateTimeCol({
    ident: 'createdDate',
    display: 'Created Date',
    width: 200,
  }),

  modifiedDateCol,
  strCol({
    ident: 'createdBy',
    display: 'Created By',
  }),
  // modifierCol,
  {
    ident: 'modifier',
    display: 'Modifier',
    dataGetter: modifierGetter,
    showInRowEditor: false,
    type: 'str',
    width: 100,
    isKey: true,
  },
  strCol({
    ident: 'status',
    display: 'Status',
  }),
  strCol({
    ident: 'deleted',
    display: 'Deleted',
  }),

  numCol({
    ident: 'netMaxCap',
    display: 'Net Maximum Capacity',
  }),
  numCol({
    ident: 'netDapCap',
    display: 'Net Dependable Capacity',
  }),
  numCol({
    ident: 'netActGen',
    display: 'Net Actual Generation',
  }),
  numCol({
    ident: 'loadChar',
    display: 'Load Characteristics',
  }),
  numCol({
    ident: 'attStart',
    display: 'Attempted Starts',
  }),
  numCol({
    ident: 'actualStart',
    display: 'Actual Starts',
  }),
  strCol({
    ident: 'loadDesc',
    display: 'Load Description',
  }),
  numCol({
    ident: 'servHour',
    display: 'Service Hours',
  }),
  numCol({
    ident: 'resHour',
    display: 'Reserve Hours',
  }),
  numCol({
    ident: 'pumpHour',
    display: 'Pump Hours',
  }),
  numCol({
    ident: 'syncHour',
    display: 'Synchronous Hours',
  }),
].map(e => ({ ...e, isFiltered: true }))

const Card97HeadersNonFreezecolumn = [
  utilityHeader,
  unitHeader,
  intCol({
    ident: 'year',
    display: 'Year',
    isFiltered: true,
    isKey: true,
  }),
  intCol({
    ident: 'eventNum',
    display: 'Event Number',
    isKey: true,
  }),
  intCol({
    ident: 'eventIdx',
    display: 'Event Index',
    isKey: true,
  }),

  dateTimeCol({
    ident: 'createdDate',
    display: 'Created Date',
    width: 200,
  }),

  modifiedDateCol,
  strCol({
    ident: 'createdBy',
    display: 'Created By',
  }),
  // modifierCol,
  {
    ident: 'modifier',
    display: 'Modifier',
    dataGetter: modifierGetter,
    showInRowEditor: false,
    type: 'str',
    width: 100,
    isKey: true,
  },
  strCol({
    ident: 'status',
    display: 'Status',
  }),
  strCol({
    ident: 'deleted',
    display: 'Deleted',
  }),
  strCol({
    ident: 'eventType',
    display: 'Event Type',
    isKey: true,
  }),
  numCol({
    ident: 'ioCode',
    display: 'IO Code',
  }),
  dateTimeCol({
    ident: 'eventStart',
    display: 'Event Start Date',
    width: 200,
  }),
  dateTimeCol({
    ident: 'eventEnd',
    display: 'Event End Date',
    width: 200,
  }),
  numCol({
    ident: 'availCap',
    display: 'Available Capacity',
    width: 150,
  }),
  numCol({
    ident: 'causeCode',
    display: 'Cause Code',
  }),
  strCol({
    ident: 'conCode',
    display: 'Contribution Code',
    width: 150,
  }),
  dateTimeCol({
    ident: 'workStart',
    display: 'Work Start Date',
    width: 200,
  }),
  dateTimeCol({
    ident: 'workEnd',
    display: 'Work End Date',
    width: 200,
  }),
  numCol({
    ident: 'manHour',
    display: 'Man Hours',
  }),

  strCol({
    ident: 'failCode',
    display: 'Fail/Amp Code',
  }),
  strCol({
    ident: 'description',
    display: 'Description',
    width: 500,
  }),
].map(e => ({ ...e, isFiltered: true }))

const Card97HeadersFreezeColumn = [
  // utilityHeader,
  unitHeader,
  intCol({
    ident: 'year',
    display: 'Year',
    isFiltered: true,
    isKey: true,
    width: 80,
  }),
  intCol({
    ident: 'eventNum',
    display: 'Event Number',
    isKey: true,
    width: 80,
  }),
  intCol({
    ident: 'eventIdx',
    display: 'Event Index',
    isKey: true,
    width: 80,
  }),
  strCol({
    ident: 'utility',
    display: 'Utility',
    width: 350,
    // isKey: true,
    sortOrder: 'asc',
    ellipsis: true,
  }),
  dateTimeCol({
    ident: 'createdDate',
    display: 'Created Date',
    width: 200,
  }),
  strCol({
    ident: 'eventType',
    display: 'Event Type',
    isKey: true,
  }),
  modifiedDateCol,
  strCol({
    ident: 'createdBy',
    display: 'Created By',
  }),
  // modifierCol,
  {
    ident: 'modifier',
    display: 'Modifier',
    dataGetter: modifierGetter,
    showInRowEditor: false,
    type: 'str',
    width: 100,
    isKey: true,
  },
  strCol({
    ident: 'status',
    display: 'Status',
  }),
  strCol({
    ident: 'deleted',
    display: 'Deleted',
  }),

  numCol({
    ident: 'ioCode',
    display: 'IO Code',
  }),
  dateTimeCol({
    ident: 'eventStart',
    display: 'Event Start Date',
    width: 200,
  }),
  dateTimeCol({
    ident: 'eventEnd',
    display: 'Event End Date',
    width: 200,
  }),
  numCol({
    ident: 'availCap',
    display: 'Available Capacity',
    width: 150,
  }),
  numCol({
    ident: 'causeCode',
    display: 'Cause Code',
  }),
  strCol({
    ident: 'conCode',
    display: 'Contribution Code',
    width: 150,
  }),
  dateTimeCol({
    ident: 'workStart',
    display: 'Work Start Date',
    width: 200,
  }),
  dateTimeCol({
    ident: 'workEnd',
    display: 'Work End Date',
    width: 200,
  }),
  numCol({
    ident: 'manHour',
    display: 'Man Hours',
  }),

  strCol({
    ident: 'failCode',
    display: 'Fail/Amp Code',
  }),
  strCol({
    ident: 'description',
    display: 'Description',
    width: 500,
  }),
].map(e => ({ ...e, isFiltered: true }))

const Card99HeadersNonFreezeColumn = [
  utilityHeader,
  unitHeader,
  intCol({
    ident: 'year',
    display: 'Year',
    isFiltered: true,
    isKey: true,
  }),
  intCol({
    ident: 'month',
    display: 'Month',
    isFiltered: true,
    isKey: true,
  }),

  dateTimeCol({
    ident: 'createdDate',
    display: 'Created Date',
    width: 200,
  }),

  modifiedDateCol,
  strCol({
    ident: 'createdBy',
    display: 'Created By',
  }),
  // modifierCol,
  {
    ident: 'modifier',
    display: 'Modifier',
    dataGetter: modifierGetter,
    showInRowEditor: false,
    type: 'str',
    width: 100,
    isKey: true,
  },
  strCol({
    ident: 'status',
    display: 'Status',
  }),
  strCol({
    ident: 'deleted',
    display: 'Deleted',
  }),
  strCol({
    ident: 'pFuel',
    display: 'Primary Fuel',
  }),
  numCol({
    ident: 'pBurned',
    display: 'Primary Fuel Burned',
  }),
  numCol({
    ident: 'pAvgHeat',
    display: 'Primary Avg Heat',
  }),
  numCol({
    ident: 'pAsh',
    display: 'Primary Ash Content',
  }),
  numCol({
    ident: 'pMoist',
    display: 'Primary Moisture Content',
  }),
  numCol({
    ident: 'pSulfur',
    display: 'Primary Sulfur Content',
  }),
  strCol({
    ident: 'sFuel',
    display: 'Secondary Fuel',
  }),
  numCol({
    ident: 'sBurned',
    display: 'Secondary Fuel Burned',
  }),
  numCol({
    ident: 'sAvgHeat',
    display: 'Secondary Avg Heat',
  }),
  numCol({
    ident: 'sAsh',
    display: 'Secondary Ash Content',
  }),
  numCol({
    ident: 'sMoist',
    display: 'Secondary Moisture Content',
  }),
  numCol({
    ident: 'sSulfur',
    display: 'Secondary Sulfur Content',
  }),
  strCol({
    ident: 'tFuel',
    display: 'Tertiary Fuel',
  }),
  numCol({
    ident: 'tBurned',
    display: 'Tertiary Fuel Burned',
  }),
  numCol({
    ident: 'tAvgHeat',
    display: 'Tertiary Avg Heat',
  }),
  numCol({
    ident: 'tAsh',
    display: 'Tertiary Ash Content',
  }),
  numCol({
    ident: 'tMoist',
    display: 'Tertiary Moisture Content',
  }),
  numCol({
    ident: 'tSulfur',
    display: 'Tertiary Sulfur Content',
  }),
  strCol({
    ident: 'qFuel',
    display: 'Quaternary Fuel',
  }),
  numCol({
    ident: 'qBurned',
    display: 'Quaternary Fuel Burned',
  }),
  numCol({
    ident: 'qAvgHeat',
    display: 'Quaternary Avg Heat',
  }),
  numCol({
    ident: 'qAsh',
    display: 'Quaternary Ash Content',
  }),
  numCol({
    ident: 'qMoist',
    display: 'Quaternary Moisture Content',
  }),
  numCol({
    ident: 'qSulfur',
    display: 'Quaternary Sulfur Content',
  }),
].map(e => ({ ...e, isFiltered: true }))

const Card99HeadersFreezcolumns = [
  // utilityHeader,
  unitHeader,
  intCol({
    ident: 'year',
    display: 'Year',
    isFiltered: true,
    isKey: true,
    width: 80,
  }),
  intCol({
    ident: 'month',
    display: 'Month',
    isFiltered: true,
    isKey: true,
    width: 80,
  }),
  strCol({
    ident: 'utility',
    display: 'Utility',
    width: 350,
    // isKey: true,
    sortOrder: 'asc',
    ellipsis: true,
  }),

  dateTimeCol({
    ident: 'createdDate',
    display: 'Created Date',
    width: 200,
  }),

  modifiedDateCol,
  strCol({
    ident: 'createdBy',
    display: 'Created By',
  }),
  // modifierCol,
  {
    ident: 'modifier',
    display: 'Modifier',
    dataGetter: modifierGetter,
    showInRowEditor: false,
    type: 'str',
    width: 100,
    isKey: true,
  },
  strCol({
    ident: 'status',
    display: 'Status',
  }),
  strCol({
    ident: 'deleted',
    display: 'Deleted',
  }),
  strCol({
    ident: 'pFuel',
    display: 'Primary Fuel',
  }),
  numCol({
    ident: 'pBurned',
    display: 'Primary Fuel Burned',
  }),
  numCol({
    ident: 'pAvgHeat',
    display: 'Primary Avg Heat',
  }),
  numCol({
    ident: 'pAsh',
    display: 'Primary Ash Content',
  }),
  numCol({
    ident: 'pMoist',
    display: 'Primary Moisture Content',
  }),
  numCol({
    ident: 'pSulfur',
    display: 'Primary Sulfur Content',
  }),
  strCol({
    ident: 'sFuel',
    display: 'Secondary Fuel',
  }),
  numCol({
    ident: 'sBurned',
    display: 'Secondary Fuel Burned',
  }),
  numCol({
    ident: 'sAvgHeat',
    display: 'Secondary Avg Heat',
  }),
  numCol({
    ident: 'sAsh',
    display: 'Secondary Ash Content',
  }),
  numCol({
    ident: 'sMoist',
    display: 'Secondary Moisture Content',
  }),
  numCol({
    ident: 'sSulfur',
    display: 'Secondary Sulfur Content',
  }),
  strCol({
    ident: 'tFuel',
    display: 'Tertiary Fuel',
  }),
  numCol({
    ident: 'tBurned',
    display: 'Tertiary Fuel Burned',
  }),
  numCol({
    ident: 'tAvgHeat',
    display: 'Tertiary Avg Heat',
  }),
  numCol({
    ident: 'tAsh',
    display: 'Tertiary Ash Content',
  }),
  numCol({
    ident: 'tMoist',
    display: 'Tertiary Moisture Content',
  }),
  numCol({
    ident: 'tSulfur',
    display: 'Tertiary Sulfur Content',
  }),
  strCol({
    ident: 'qFuel',
    display: 'Quaternary Fuel',
  }),
  numCol({
    ident: 'qBurned',
    display: 'Quaternary Fuel Burned',
  }),
  numCol({
    ident: 'qAvgHeat',
    display: 'Quaternary Avg Heat',
  }),
  numCol({
    ident: 'qAsh',
    display: 'Quaternary Ash Content',
  }),
  numCol({
    ident: 'qMoist',
    display: 'Quaternary Moisture Content',
  }),
  numCol({
    ident: 'qSulfur',
    display: 'Quaternary Sulfur Content',
  }),
].map(e => ({ ...e, isFiltered: true }))
